//dashboard_client
import React, { useContext, Fragment, useEffect, useState } from 'react'
import { AuthContext } from '../../context/auth_context';
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";
import { IoMdArrowDropdown } from 'react-icons/io';
import { CgLogOut, CgHashtag } from 'react-icons/cg';
import { AiFillFolder, AiFillFile, AiOutlineSearch } from 'react-icons/ai'
import { BsFillPersonFill, BsClock, BsCheck } from 'react-icons/bs'
import Renderif from '../../components/renderif';
import SideMenu from '../../components/sidemenu';
import CheckBox from '../../components/checkbox';
import DropDown, { DropDownOption } from '../../components/dropdown';
import { gray10, gray30, gray40, green, primary } from '../../utils/colors';
import { Service } from '../../services/api';
import AgendarCita from './agendar_client';
import TipCard from '../../components/tipcard';
import { BiEdit } from 'react-icons/bi';
import EditarCitaClient from './editar_cita_client';
import { FaPeopleGroup } from 'react-icons/fa6';
import { FaRegCircle } from 'react-icons/fa';
import { IoIosArrowDown, IoIosArrowForward, IoMdCalendar, IoIosArrowBack } from 'react-icons/io'
import { MdTipsAndUpdates, MdCalendarMonth, MdNotificationsNone } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { GoGear } from 'react-icons/go';
import { RiMapPin2Line } from 'react-icons/ri';
import { MdOutlineMessage } from 'react-icons/md';
import { AlertContext } from '../../context/alert_context'
import { AiFillCloseCircle } from 'react-icons/ai'
import BVCalendar from '../../components/calendar'
import { BiCheck } from 'react-icons/bi'
import { IoOpenOutline } from 'react-icons/io5'


export default function DashboardClient() {
    const navigate = useNavigate();
    const { user, logout } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)

    let date = new Date();
    date.setDate(date.getDate() + 1)

    const [state, setState] = useState({
        tab: 0,
        show_cita_detail_id: null,
        show_agendar_cita: false,
        show_editar_cita: false,
        show_question_edit_cita: false,
        show_change_date_cita: false,
        cita_editing: null,
        next_citas: [],
        prev_citas: [],
        all_citas: [],
        date_selected: null,
        search: '',
        filter: '',
        on_cancel: false,
        selected_time: '',
        selected_daytime: null,
        selected_day: date,
        following: 'Acuerdos',
    })

    useEffect(() => {
        const init = async () => {
            let citas = await Service('GET', 'Appointment?pageNumber=1&pageSize=999');
            console.log(citas);
            citas.data.data.map((e, a) => {
                // console.log(e.dateOfEvent)
                // console.log(citas.data)
            })

            let today = new Date();
            let next_citas = citas.data.data.filter((cita) => new Date(cita[0].dateOfEvent) > today).sort((citaA, citaB) => Number(new Date(citaA.dateOfEvent)) - Number(new Date(citaB.dateOfEvent)))

            let prev_citas = citas.data.data.filter((cita) => new Date(cita[0].dateOfEvent) < today).sort((citaA, citaB) => Number(new Date(citaA.dateOfEvent)) - Number(new Date(citaB.dateOfEvent)))

            next_citas.sort((a, b) => new Date(a[0].dateOfEvent).getTime() - new Date(b[0].dateOfEvent).getTime());
            prev_citas.sort((a, b) => new Date(b[0].dateOfEvent).getTime() - new Date(a[0].dateOfEvent).getTime());



            setState({ ...state, next_citas, prev_citas, all_citas: citas.data.data.sort((a, b) => new Date(a[0].dateOfEvent).getTime() - new Date(b[0].dateOfEvent).getTime()) })
        }
        init();
        return () => { }
    }, [])

    const getCitas = async () => {

        let citas = await Service('GET', 'Appointment?pageNumber=1&pageSize=999');

        let today = new Date();
        let next_citas = citas.data.data.filter((cita) => new Date(cita.dateOfEvent) > today).sort((citaA, citaB) => Number(new Date(citaA.dateOfEvent)) - Number(new Date(citaB.dateOfEvent)))

        let prev_citas = citas.data.data.filter((cita) => new Date(cita.dateOfEvent) < today).sort((citaA, citaB) => Number(new Date(citaA.dateOfEvent)) - Number(new Date(citaB.dateOfEvent)))
        next_citas.sort((a, b) => new Date(a[0].dateOfEvent).getTime() - new Date(b[0].dateOfEvent).getTime());
        prev_citas.sort((a, b) => new Date(b[0].dateOfEvent).getTime() - new Date(a[0].dateOfEvent).getTime());
        // console.log(prev_citas)



        setState({ ...state, next_citas, prev_citas, show_editar_cita: false })
    }

    const arr = [1, 1, 1, 1, 1, 1, 1]
    var weekday = new Array(7);
    weekday[0] = "Domingo";
    weekday[1] = "Lunes";
    weekday[2] = "Martes";
    weekday[3] = "Miercoles";
    weekday[4] = "Jueves";
    weekday[5] = "Viernes";
    weekday[6] = "Sabado";

    var months = new Array(7);
    months[0] = "Enero";
    months[1] = "Febrero";
    months[2] = "Marzo";
    months[3] = "Abril";
    months[4] = "Mayo";
    months[5] = "Junio";
    months[6] = "Julio";
    months[7] = "Agosto";
    months[8] = "Septiembre";
    months[9] = "Octubre";
    months[10] = "Noviembre";
    months[11] = "Diciembre";

    function convertUTCDateToLocalDate(date) {
        var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();
        newDate.setHours(hours - offset);
        return newDate;
    }

    const filter = (data) => {
        return data;

        if (state.date_selected === null) {

            let filtered = data.filter((item) =>
                item.description?.toUpperCase().includes(state.search?.toUpperCase()) ||
                item.specialist?.firstName?.toUpperCase().includes(state.search?.toUpperCase()) ||
                item.patient?.firstName?.toUpperCase().includes(state.search?.toUpperCase()) ||
                item.patient?.proceedings?.toUpperCase().includes(state.search?.toUpperCase())
            )
            return filtered;

        }

        let dates = []
        data.map((item) => {
            let event = new Date(item.dateOfEvent);
            if (
                event.getDate() === state.date_selected.getDate() &&
                event.getMonth() === state.date_selected.getMonth() &&
                event.getDay() === state.date_selected.getDay()
            ) {
                dates.push(item)
            }
        })
        return dates;


    }

    const onCancel = async () => {
        // console.log(state.cita_editing.id);

        let _delete = await Service('DELETE', `Appointment/${state.cita_editing.id}`)
        if (_delete?.status === 200) {
            setState({ ...state, on_cancel: false })
            notify({ title: 'Listo!', message: 'Tu cita ha sido cancelada.', type: 'success' })

        } else {
            notify({ title: 'Error!', message: 'No ha sido posible cancelar tu cita.', type: 'error' })
        }

    }


    return (
        <>

            <Renderif isTrue={state.on_cancel === true}>
                <div className='overlay d-flex justify-content-center align-items-center'>
                    <div className='bv-modal shadow p-4'>
                        <div className='h5'>
                            Cancelar cita
                        </div>
                        <div className='f-14 text-gray my-2'>
                            ¿Estás seguro de que quieres cancelar esta cita?
                        </div>
                        <div className='bg-gray--txt-black p-2 my-4 bdr-10'>

                            <div className='card-notification flex-center-j-left m-2'>
                                <div className=''>
                                    <div className='avatar-profile'></div>
                                </div>
                                <div className='p-2'>
                                    <div className='bold f-14'>
                                        Dr {state.cita_editing?.specialist?.firstName} {state.cita_editing?.specialist?.lastName}
                                    </div>
                                    <div className='f-12'>
                                        Psicólogo
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex m-2'>
                                <div className='flex-center'>
                                    <IoMdCalendar size={18} color={'#000000'}></IoMdCalendar> {weekday[new Date(state.cita_editing?.dateOfEvent).getDay()]} {new Date(state.cita_editing?.dateOfEvent).getDate()} de {months[new Date(state.cita_editing?.dateOfEvent).getMonth()]} {new Date(state.cita_editing?.dateOfEvent).getFullYear()} | {new Date(state.cita_editing?.dateOfEvent).getHours()}:{new Date(state.cita_editing?.dateOfEvent).getMinutes()}-{new Date(state.cita_editing?.dateOfEvent).getHours() + 1}:{new Date(state.cita_editing?.dateOfEvent).getMinutes()}
                                </div>
                                <div className='col'>

                                </div>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='col'></div>

                            <div className='d-flex mb-'>
                                <div className='pe-2 flex-center'>
                                    <div className={`bv-cta-curve bv-tab--active-gray bv-icon bv-icon--mid`} onClick={() => {
                                        setState({ ...state, on_cancel: false })
                                    }}>
                                        Mantener
                                    </div>
                                </div>
                                <div className='pe-2 flex-center'>
                                    <div className={`bv-cta-curve bv-cta--option-red bv-icon bv-icon--mid`} onClick={() => {
                                        onCancel()
                                    }}>
                                        Cancelar
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </Renderif>

            <Renderif isTrue={state.show_question_edit_cita === true}>
                <div className='overlay d-flex justify-content-center align-items-center'>
                    <div className='bv-modal shadow p-4'>
                        <div className='h5'>
                            Selecciona una opcion a continuación
                        </div>
                        <div className='f-14 text-gray my-2'>
                            ¿Deseas reagendarla o cambiar de coach?
                        </div>
                        <div className='bg-gray--txt-black p-2 my-4 bdr-10'>

                            <div className='card-notification flex-center-j-left m-2'>
                                <div className=''>
                                    <div className='avatar-profile'></div>
                                </div>
                                <div className='p-2'>
                                    <div className='bold f-14'>
                                        Dr {state.cita_editing?.specialist?.firstName} {state.cita_editing?.specialist?.lastName}
                                    </div>
                                    <div className='f-12'>
                                        Psicólogo
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex m-2'>
                                <div className='flex-center'>
                                    <IoMdCalendar size={18} color={'#000000'}></IoMdCalendar> {weekday[new Date(state.cita_editing?.dateOfEvent).getDay()]} {new Date(state.cita_editing?.dateOfEvent).getDate()} de {months[new Date(state.cita_editing?.dateOfEvent).getMonth()]} {new Date(state.cita_editing?.dateOfEvent).getFullYear()} | {new Date(state.cita_editing?.dateOfEvent).getHours()}:{new Date(state.cita_editing?.dateOfEvent).getMinutes()}-{new Date(state.cita_editing?.dateOfEvent).getHours() + 1}:{new Date(state.cita_editing?.dateOfEvent).getMinutes()}
                                </div>
                                <div className='col'>

                                </div>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='col'></div>

                            <div className='d-flex mb-'>
                                <div className='pe-2 flex-center'>
                                    <div className={`bv-cta-curve bv-tab--active-gray bv-icon bv-icon--mid`} onClick={() => {
                                        setState({ ...state, show_question_edit_cita: false })
                                    }}>
                                        Mantener
                                    </div>
                                </div>
                                <div className='pe-2 flex-center'>
                                    <div className={`bv-cta-curve bv-tab--active-gray bv-icon bv-icon--mid`} onClick={() => {
                                        // onCancel()
                                        setState({ ...state, show_question_edit_cita: false, show_change_date_cita: true })
                                    }}>
                                        Reagendar
                                    </div>
                                </div>
                                <div className='pe-2 flex-center'>
                                    <div className={`bv-cta-curve bv-tab--active-gray bv-icon bv-icon--mid`} onClick={() => {
                                        // onCancel()
                                    }}>
                                        Cambiar coach
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </Renderif>
            <Renderif isTrue={state.show_change_date_cita === true}>
                <div className='bv-modal shadow'>

                    <div className='px-4 pt-3 pb-4 d-flex flex-column align-items-center'>

                        <div className='d-flex align-items-center w-100'>

                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                // props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='f-18 text-gray bold'>Reagendar Cita</div>





                        <div className='d-flex overflow-hidden py-2 px-4'>

                            <div className='col'>
                                <BVCalendar init={date} onChange={(evt) => {
                                    // console.log(evt)
                                    // if(evt < new Date()){
                                    //     console.log("NEL")
                                    //     return;
                                    // }
                                    setState({ ...state, selected_day: evt })
                                }}></BVCalendar>
                            </div>

                            <div className='col overflow-auto hide-scroll ps-3 d-none'>



                                {
                                    arr.map((item, i) => {
                                        return (
                                            <div key={i} className={`d-flex align-items-center py-2 b-bottom ps-1 ${state.selected_time === i ? 'highlight-active' : ''}`}>
                                                <div className='col f-12 text-gray'>{weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()}</div>
                                                <div className='col f-12 text-gray'>{months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}</div>
                                                <div className='col f-12 text-gray'>{item}</div>
                                                <div className={`bv-pill cursor-pointer ${state.selected_time === i ? 'bv-pill--primary' : 'bv-pill--gray'}`} onClick={() => {



                                                    let daytime = new Date(new Date(state.selected_day).setHours(item.split(':')[0], item.split(':')[1], '00'));
                                                    console.log(daytime)

                                                    setState({ ...state, selected_time: i, selected_daytime: daytime })
                                                }}>Seleccionar</div>
                                            </div>
                                        )
                                    })
                                }


                            </div>
                            <div className='col overflow-auto hide-scroll ps-3'>

                                <Renderif isTrue={state.selected_day < new Date()}>
                                    <div className='f-14 bold text-gray'>En BienVivir, programar citas solo es posible a partir del día siguiente.</div>
                                </Renderif>

                                <Renderif isTrue={state.selected_day > new Date()}>
                                    {
                                        arr.map((item, i) => {
                                            return (
                                                <div key={i} className={`d-flex align-items-center justify-content-center py-2 b-bottom ps-1 highlight-hover ${state.selected_time === i ? 'highlight-active' : ''}`} onClick={() => {
                                                    let daytime = new Date(new Date(state.selected_day).setHours(item.split(':')[0], item.split(':')[1], '00'));
                                                    console.log(daytime)

                                                    setState({ ...state, selected_time: i, selected_daytime: daytime })
                                                }}>
                                                    <div className='col f-12 text-gray'>{weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()}</div>
                                                    <div className='col f-12 text-gray'>{months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}</div>
                                                    <div className='col f-12 text-gray'>{item}</div>
                                                    <div className='bv-icon bv-icon--mid me-2'>
                                                        <BiCheck size={28} color={`${state.selected_time === i ? '#0972CE' : 'transparent'}`}></BiCheck>
                                                    </div>
                                                    {/* <div className={`bv-pill cursor-pointer ${i === 0 ? 'bv-pill--primary':'bv-pill--gray'}`}>Seleccionar</div> */}
                                                </div>
                                            )
                                        })
                                    }
                                </Renderif>


                            </div>
                        </div>




                    </div>
                    <div className='d-flex b-top p-4'>
                        <div className='col'></div>
                        <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                            // props.onCancel()
                        }}>Cancelar</div>
                        <div className='bv-pill bv-pill--primary cursor-pointer px-4' onClick={() => {


                            // onReSchedule()

                        }}>Reagendar Cita</div>
                    </div>

                </div>
            </Renderif>
            {/* <Renderif isTrue={state.show_agendar_cita}>
                <AgendarCita onSchedule={(cita) => {
                    state.next_citas.unshift(cita)
                    setState({ ...state, show_agendar_cita: false })
                }} onCancel={() => {
                    setState({ ...state, show_agendar_cita: false })
                }}></AgendarCita>

            </Renderif>

            <Renderif isTrue={state.show_editar_cita}>
                <EditarCitaClient
                    cita={state.cita_editing}
                    onDelete={(cita) => {
                        state.next_citas = state.next_citas.filter((item) => item.id !== cita.id)
                        setState({ ...state, show_agendar_cita: false })
                    }}
                    onSchedule={(cita) => {

                        getCitas()
                    }}
                    onCancel={() => {
                        setState({ ...state, show_editar_cita: false })
                    }}></EditarCitaClient>
            </Renderif> */}



            <div className='container-fluid h-100 d-flex bacground-gray'>

                <SideMenu></SideMenu>

                <div className='col hide-scroll'>


                    <div className='container-fluid'>
                        <div className='row'>

                            <div className='d-flex flex-lg-row p-2 p-sm-3 bg-white border-b'>

                                <div className='d-flex align-items-center'>
                                    <div className='input--light-curve'>
                                        <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                                        <input placeholder='Busca Tips, Documentos, etc.'></input>
                                    </div>
                                </div>
                                <div className='col'></div>

                                <div className='d-flex flex-column flex-md-row align-items-md-center justify-content-end'>

                                    <div className='d-flex py-1 py-sm-2 order-0 order-md-1'>
                                        <div className='pe-2 cita-button flex-center'>
                                            <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid' onClick={() => {
                                                // setState({ ...state, show_agendar_cita: true })
                                                navigate('/client/crear-cita')
                                            }}>
                                                <MdCalendarMonth size={20} className='me-2'></MdCalendarMonth>
                                                Agendar cita
                                            </div>
                                        </div>
                                        <div className='pe-2'>
                                            <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                                                if (state.notifications_menu) {
                                                    setState({ ...state, notifications_menu: false })
                                                } else {
                                                    setState({ ...state, notifications_menu: true })
                                                }

                                            }}><MdNotificationsNone size={24} color={gray40}></MdNotificationsNone>
                                                <Renderif isTrue={state.notifications_menu}>
                                                    <div className='float-menu'>
                                                        <div className='h-menu flex-center-left separator-h-bottom p-2'>
                                                            Notificaciones
                                                        </div>
                                                        <div className='b-menu'>
                                                            <div className='card-notification d-flex separator-h-top'>
                                                                <div className=''>
                                                                    <div className='avatar-profile'></div>
                                                                </div>
                                                                <div className='flex-center f-12 p-2'>
                                                                    Por el momento no cuenta con notificaciones
                                                                </div>
                                                            </div>
                                                            {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div> */}
                                                        </div>
                                                    </div>
                                                </Renderif>
                                            </div>
                                        </div>

                                        <div className='pe-2 me-4 agreements'>
                                            <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                                                if (state.agreements_menu) {
                                                    setState({ ...state, agreements_menu: false })
                                                } else {
                                                    setState({ ...state, agreements_menu: true })
                                                }

                                            }}><FaPeopleGroup size={24} color={gray40}></FaPeopleGroup>
                                                <Renderif isTrue={state.agreements_menu}>
                                                    <div className='float-menu'>
                                                        <div className='h-menu flex-center-left separator-h-bottom p-2'>
                                                            Acuerdos pendientes
                                                        </div>
                                                        <div className='b-menu'>
                                                            <div className='card-notification d-flex separator-h-top'>
                                                                <div className='flex-center ms-2'>
                                                                    <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                                </div>
                                                                <div className='flex-center f-12 p-2'>
                                                                    Por el momento no cuenta con acuerdos
                                                                </div>
                                                            </div>
                                                            {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Hacer ejercicio
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Leer
                                                            </div>
                                                        </div> */}
                                                        </div>
                                                    </div>
                                                </Renderif>
                                            </div>
                                        </div>

                                        <div className='pe-2 px-md-2 flex-center separator-v-left cursor-pointer' onClick={() => {
                                            if (state.profile_menu) {
                                                setState({ ...state, profile_menu: false })
                                            } else {
                                                setState({ ...state, profile_menu: true })
                                            }

                                        }}>
                                            <div className='avatar-profile  ms-lg-3'></div>
                                            <div className=''>
                                                <IoIosArrowDown size={18} color={'#000000'}></IoIosArrowDown>

                                            </div>

                                        </div>
                                        <Renderif isTrue={state.profile_menu}>
                                            <div className='float-menu-profile'>
                                                <div className='b-menu'>
                                                    <div className='card-notification flex-center-j-left m-2'>
                                                        <div className=''>
                                                            <div className='avatar-profile'></div>
                                                        </div>
                                                        <div className='p-2'>
                                                            <div className='bold f-14'>
                                                                {user?.firstName} {user?.lastName}
                                                            </div>
                                                            <div className='f-12 text-miperfil bold cursor-pointer' onClick={() => {
                                                                navigate('/client/profile')
                                                            }}>
                                                                Mi perfil
                                                                <IoIosArrowForward size={12} color={primary} className='ms-1'></IoIosArrowForward>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='b-menu'>
                                                    <div className='card-notification d-flex separator-h-top cursor-pointer'>
                                                        <div className='flex-center ms-2'>
                                                            <GoGear size={15} color={gray40}></GoGear>
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            Configuración
                                                        </div>
                                                    </div>
                                                    <div className='card-notification d-flex separator-h-top cursor-pointer' onClick={() => {
                                                        logout();
                                                        navigate('/')
                                                    }}>
                                                        <div className='flex-center ms-2'>
                                                            <CgLogOut size={15} color={gray40} />
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            Cerrar sesión
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Renderif>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>



                    {/* <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12 col-xl-9 p-2 p-sm-3'>
                                <div className='d-flex align-items-center'>
                                    <div className={`bv-tab bv-tab--primary ${state.tab === 0 ? 'bv-tab--active' : ''}`} onClick={() => {
                                        setState({ ...state, tab: 0 })
                                    }}>Próximas Citas <span className='text-blue f-12 bold ms-2'>{state.next_citas.length}</span> </div>
                                    <div className={`bv-tab bv-tab--primary ${state.tab === 1 ? 'bv-tab--active' : ''}`} onClick={() => {
                                        setState({ ...state, tab: 1 })
                                    }}>Citas Anteriores <span className='text-blue f-12 bold ms-2'>{state.prev_citas.length}</span></div>
                                    <div className='col'></div>
                                    <DropDown
                                        title=''
                                        styles={''}
                                        open={false}
                                        defaultValue={10}
                                        _onChange={(evt) => {
                                            console.log(evt)
                                        }}>
                                        <DropDownOption value={5} label="Todo">
                                            <div className='f-14 text-gray'>Todo</div>
                                        </DropDownOption>
                                        <DropDownOption value={10} label="Familia">
                                            <div className='f-14 text-gray'>Familia</div>
                                        </DropDownOption>

                                    </DropDown>
                                </div>
                            </div>

                        </div>
                    </div> */}


                    {/* <div className='d-sm-none mt-3 mb-4'>
                        <Renderif isTrue={state.tab === 0}>
                            {state.next_citas.map((item, i) => {
                                return (
                                    <CitaItem cita={item} key={i}></CitaItem>
                                )
                            })}

                        </Renderif>
                        <Renderif isTrue={state.tab === 1}>
                            {state.prev_citas.map((item, i) => {
                                return (
                                    <CitaItem cita={item} key={i}></CitaItem>
                                )
                            })}
                        </Renderif>
                    </div> */}


                    {/* TABLA DE CITAS */}
                    {/* <div className='container-fluid mt-0 px-3'>

                        <div className='row m-0'>
                            <div className='col-12 col-xl-12 m-0 p-0'>

                                <Renderif isTrue={state.tab === 0}>
                                    <div className='bv-table d-none d-sm-block'>
                                        <table className='w-100'>
                                            <thead>
                                                <tr>
                                                    <td>
                                                        <div className='d-flex align-items-center'>

                                                            <div className='bv-icon'><BsFillPersonFill size={12} color="#777777" /></div>
                                                            <div className='text-gray line-0 f-12 bold'>Nombre</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='bv-icon'><BsCalendar size={12} color="#777777" /></div>
                                                            <div className='text-gray f-12 bold line-0'>Fecha</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='bv-icon'><BsClock size={12} color="#777777" /></div>
                                                            <div className='text-gray f-12 bold line-0'>Hora</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div>
                                                            <div className='text-gray f-12 bold line-0'>Sesión</div>
                                                        </div>
                                                    </td>
                                                    <td></td>
                                                    <td></td>


                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filter(state.next_citas.filter((item => item[0].patient.firstName.toUpperCase().includes(state.filter.toUpperCase())))).map((cita, i) => {
                                                    let item = cita[0]
                                                    return (
                                                        <Fragment key={i}>
                                                            <tr className="">
                                                                <td>
                                                                    <div>
                                                                        <div className='text-gray f-12'>{item.specialist.firstName} {item.specialist.lastName}</div>
                                                                        <div className='text-gray f-10'>{item.specialist.email}</div>
                                                                    </div>
                                                                </td>

                                                                <td><div className='text-gray f-12'>{weekday[new Date(item.dateOfEvent).getDay()]} {new Date(item.dateOfEvent).getDate()} {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()}</div></td>
                                                                <td><div className='text-gray text-center f-12'>{new Date(item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes()}</div></td>
                                                                <td><div className='text-black bold f-12 text-center '>{item.numberOfSession}</div></td>
                                                                <td>
                                                                    <div className='d-flex overlap-content d-none'>
                                                                        <div className='avatar' style={{ 'backgroundImage': 'url("https://xsgames.co/randomusers/assets/avatars/female/65.jpg")' }}></div>
                                                                        <div className='avatar' style={{ 'backgroundImage': 'url("https://xsgames.co/randomusers/assets/avatars/male/66.jpg")' }}></div>
                                                                        <div className='avatar' style={{ 'backgroundImage': 'url("https://xsgames.co/randomusers/assets/avatars/female/61.jpg")' }}></div>
                                                                    </div>
                                                                </td>


                                                                <td>
                                                                    <div className='d-flex'>
                                                                        <div className='col'></div>
                                                                        <div className='pe-4'>
                                                                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                                                setState({ ...state, show_editar_cita: true, cita_editing: item })
                                                                            }}>
                                                                                <BiEdit color={primary} size={30}></BiEdit>
                                                                            </div>
                                                                        </div>
                                                                        <div className={`bv-pill cursor-pointer bv-pill--primary`} onClick={() => {
                                                                            window.open(item.sessionUrl, '_blank')
                                                                        }}>
                                                                            Video Llamada
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                            </tr>



                                                        </Fragment>
                                                    )
                                                })}

                                            </tbody>

                                        </table>

                                        <div className='pt-5'></div>
                                        <div className='mt-5'></div>

                                        <div className='d-flex align-items-center mt-5 p-2'>

                                            <div className='text-gray f-12 line-0'>Mostrar</div>


                                            <div className='mx-2'>
                                                <DropDown
                                                    title=''
                                                    open={false}
                                                    defaultValue={5}
                                                    _onChange={(evt) => {
                                                        console.log(evt)
                                                    }}>
                                                    <DropDownOption value={5} label="5">
                                                        <div className='f-14 text-gray'>5</div>
                                                    </DropDownOption>
                                                    <DropDownOption value={10} label="10">
                                                        <div className='f-14 text-gray'>10</div>
                                                    </DropDownOption>



                                                </DropDown>
                                            </div>


                                            <div className='text-gray f-12 line-0'>Por Página</div>
                                            <div className='col'></div>


                                        </div>
                                    </div>
                                </Renderif>


                                <Renderif isTrue={state.tab === 1}>
                                    <div className='bv-table d-none d-sm-block'>
                                        <table className='w-100'>
                                            <thead>
                                                <tr>
                                                    <td>
                                                        <div className='d-flex align-items-center'>


                                                            <div className='bv-icon'><BsFillPersonFill size={12} color="#777777" /></div>
                                                            <div className='text-gray line-0 f-12 bold'>Nombre</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='bv-icon'><BsCalendar size={12} color="#777777" /></div>
                                                            <div className='text-gray f-12 bold line-0'>Fecha</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='bv-icon'><BsClock size={12} color="#777777" /></div>
                                                            <div className='text-gray f-12 bold line-0'>Hora</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div>
                                                            <div className='text-gray f-12 bold line-0'>Sesión</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='bv-icon'><AiFillFolder size={16} color="#777777" /></div>
                                                            <div className='text-gray f-12 bold line-0'>Expediente</div>
                                                        </div>
                                                    </td>
                                                    <td></td>



                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.prev_citas.filter((item => item[0].patient.firstName.toUpperCase().includes(state.filter.toUpperCase()))).map((cita, i) => {
                                                    let item = cita[0]
                                                    // console.log(item);
                                                    return (
                                                        <Fragment key={i}>
                                                            <tr>
                                                                <td>
                                                                    <div>
                                                                        <div className='text-gray f-12'>{item.specialist.firstName} {item.specialist.lastName}</div>
                                                                        <div className='text-gray f-10'>{item.specialist.email}</div>
                                                                    </div>
                                                                </td>

                                                                <td><div className='text-gray f-12'>{weekday[new Date(item.dateOfEvent).getDay()]} {new Date(item.dateOfEvent).getDate()} {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()}</div></td>
                                                                <td><div className='text-gray text-center f-12'>{new Date(item.dateOfEvent).getHours()}:00</div></td>
                                                                <td><div className='text-black bold f-12 text-center'>{item.numberOfSession}</div></td>
                                                                <td><div className='text-gray f-12'>T1234790A</div></td>
                                                                <td>
                                                                    <div className={`bv-pill cursor-pointer ${state.show_cita_detail_id === i ? 'bv-pill--gray' : 'bv-pill--green'}`} onClick={() => {

                                                                        setState({ ...state, show_cita_detail_id: state.show_cita_detail_id === i ? null : i })
                                                                    }}>
                                                                        {state.show_cita_detail_id === i ? 'Ocultar' : 'Ver seguimiento'}

                                                                    </div>
                                                                </td>

                                                            </tr>
                                                            <Renderif isTrue={state.show_cita_detail_id === i}>
                                                                <tr className='bg-light'>
                                                                    <td colSpan={6} className='p-0'>
                                                                        <CitaDetail cita={item}></CitaDetail>
                                                                    </td>
                                                                </tr>
                                                            </Renderif>
                                                        </Fragment>
                                                    )
                                                })}

                                            </tbody>

                                        </table>

                                        <div className='pt-5'></div>
                                        <div className='mt-5'></div>

                                        <div className='d-flex align-items-center mt-5 p-2'>

                                            <div className='text-gray f-12 line-0'>Mostrar</div>


                                            <div className='d-flex bv-dropdown mx-2'>
                                                <div className='text-black bold f-12 ms-1'>5</div>
                                                <div className='line-0'><IoMdArrowDropdown size={18} color="#000000" /></div>
                                            </div>


                                            <div className='text-gray f-12 line-0'>Por Página</div>
                                            <div className='col'></div>


                                        </div>
                                    </div>
                                </Renderif>



                            </div>

                        </div>

                    </div> */}
                    {/* END TABLA DE CITAS */}

                    <div className='row my-4'>
                        <div className='col-sm-2'>

                        </div>

                        <Renderif isTrue={state.show_editar_cita === false}>
                            <div className='col-sm-8 col-12 mb-4'>
                                <div className='d-flex'>
                                    <div className='h2'>
                                        Mis citas
                                    </div>
                                    <div className='col'>

                                    </div>
                                    <div className=''>
                                        <div className='pe-2 flex-center d-sm-none'>
                                            <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid txt-white' onClick={() => {
                                                // setState({ ...state, show_agendar_cita: true })
                                                navigate('/client/crear-cita')
                                            }}>
                                                <MdCalendarMonth size={20} className='me-2'></MdCalendarMonth>
                                                Agendar cita
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='px-7 bv-card p-4'>
                                    <div className='d-flex '>
                                        <div className='pe-sm-2 flex-center'>
                                            <div className={`bv-cta-curve bv-cta--option-transparent bv-icon  ${state.tab === 0 ? 'bv-tab--active-gray' : ''}`} onClick={() => {
                                                setState({ ...state, tab: 0 })
                                            }}>
                                                Próximas
                                            </div>
                                        </div>
                                        <div className='pe-sm-2 flex-center'>
                                            <div className={`bv-cta-curve bv-cta--option-transparent bv-icon  ${state.tab === 1 ? 'bv-tab--active-gray' : ''}`} onClick={() => {
                                                setState({ ...state, tab: 1 })
                                            }}>
                                                Todas
                                            </div>
                                        </div>
                                        <div className='pe-sm-2 flex-center'>
                                            <div className={`bv-cta-curve bv-cta--option-transparent bv-icon  ${state.tab === 2 ? 'bv-tab--active-gray' : ''}`} onClick={() => {
                                                setState({ ...state, tab: 2 })
                                            }}>
                                                Completadas
                                            </div>
                                        </div>
                                    </div>


                                    <Renderif isTrue={state.tab === 0}>
                                        {state.next_citas.filter((item => item[0].patient.firstName.toUpperCase().includes(state.filter.toUpperCase()))).map((cita, i) => {
                                            let item = cita[0]
                                            // console.log(item);
                                            return (
                                                <div className='bv-card mt-4 '>
                                                    <div className='d-sm-flex m-3'>
                                                        <div className='card-notification flex-center-j-left m-2'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='p-2'>
                                                                <div className='bold f-14'>
                                                                    Dr {item.specialist.firstName} {item.specialist.lastName}
                                                                </div>
                                                                <div className='f-12'>
                                                                    Psicólogo
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col'>

                                                        </div>
                                                        <div className=''>
                                                            <div className='bv-card p-2 px-3 bold cursor-pointer' onClick={() => {
                                                                window.open(item.sessionUrl, '_blank')
                                                            }}>
                                                                Videollamada
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex mx-3'>
                                                        <div className='col'></div>
                                                        <div><IoIosArrowForward size={18} className='cursor-pointer' onClick={() => {
                                                            setState({ ...state, show_editar_cita: true, cita_editing: item })
                                                        }}></IoIosArrowForward></div>
                                                    </div>
                                                    <div className='d-flex my-3 mx-3 mx-sm-4 bg-gray--txt-black py-2 px-3 bdr-5 f-sm-14'>
                                                        <div className='flex-center'>
                                                            {/* <IoMdCalendar size={18} color={'#000000'}></IoMdCalendar> {weekday[new Date(item.dateOfEvent).getDay()]} {new Date(item.dateOfEvent).getDate()} de {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()} | {new Date(item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes()}-{new Date(item.dateOfEvent).getHours() + 1}:{new Date(item.dateOfEvent).getMinutes()} */}
                                                            <IoMdCalendar size={18} color={'#000000'}></IoMdCalendar> {new Date(item.dateOfEvent).getDate()} de {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()} | {new Date(item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes().toString().length==2?new Date(item.dateOfEvent).getMinutes():new Date(item.dateOfEvent).getMinutes()+"0"}-{new Date(item.dateOfEvent).getHours() + 1}:{new Date(item.dateOfEvent).getMinutes().toString().length==2?new Date(item.dateOfEvent).getMinutes():new Date(item.dateOfEvent).getMinutes()+"0"}
                                                        </div>
                                                        <div className='col'>

                                                        </div>
                                                        <div>
                                                            Sesión: {item.numberOfSession}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </Renderif>
                                    <Renderif isTrue={state.tab === 1}>
                                        {state.all_citas.filter((item => item[0].patient.firstName.toUpperCase().includes(state.filter.toUpperCase()))).map((cita, i) => {
                                            let item = cita[0]
                                            // console.log(item);
                                            let today = new Date();
                                            return (
                                                <div className='bv-card mt-4 '>
                                                    <div className='d-sm-flex m-3'>
                                                        <div className='card-notification flex-center-j-left m-2'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='p-2'>
                                                                <div className='bold f-14'>
                                                                    Dr {item.specialist.firstName} {item.specialist.lastName}
                                                                </div>
                                                                <div className='f-12'>
                                                                    Psicólogo
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col'>

                                                        </div>
                                                        <div className=''>
                                                            <Renderif isTrue={new Date(item.dateOfEvent) >= today}>
                                                                <div className='bv-card p-2 px-3 bold cursor-pointer' onClick={() => {
                                                                    window.open(item.sessionUrl, '_blank')
                                                                }}>
                                                                    Videollamada
                                                                </div>
                                                            </Renderif>
                                                            <Renderif isTrue={new Date(item.dateOfEvent) < today} onClick={() => {
                                                                window.open(item.sessionUrl, '_blank')
                                                            }}>
                                                                <div className='bv-green-card p-2 px-3 bold'>
                                                                    Completada
                                                                </div>
                                                            </Renderif>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex mx-3 '>
                                                        <div className='col'></div>
                                                        <div><IoIosArrowForward size={18} className='cursor-pointer' onClick={() => {
                                                            setState({ ...state, show_editar_cita: true, cita_editing: item })
                                                        }}></IoIosArrowForward></div>
                                                    </div>
                                                    <div className='d-flex my-3 mx-3 mx-sm-4 bg-gray--txt-black py-2 px-3 bdr-5 f-sm-14'>
                                                        <div className='flex-center'>
                                                            {/* <IoMdCalendar size={18} color={'#000000'}></IoMdCalendar> {weekday[new Date(item.dateOfEvent).getDay()]} {new Date(item.dateOfEvent).getDate()} de {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()} | {new Date(item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes()}-{new Date(item.dateOfEvent).getHours() + 1}:{new Date(item.dateOfEvent).getMinutes()} */}
                                                            {console.log(new Date(item.dateOfEvent).getMinutes().toString().length)}
                                                            <IoMdCalendar size={18} color={'#000000'}></IoMdCalendar> {new Date(item.dateOfEvent).getDate()} de {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()} | {new Date(item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes().toString().length==2?new Date(item.dateOfEvent).getMinutes():new Date(item.dateOfEvent).getMinutes()+"0"}-{new Date(item.dateOfEvent).getHours() + 1}:{new Date(item.dateOfEvent).getMinutes().toString().length==2?new Date(item.dateOfEvent).getMinutes():new Date(item.dateOfEvent).getMinutes()+"0"}
                                                        </div>
                                                        <div className='col'>

                                                        </div>
                                                        <div >
                                                            Sesión: {item.numberOfSession}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </Renderif>

                                    <Renderif isTrue={state.tab === 2}>
                                        {state.prev_citas.filter((item => item[0].patient.firstName.toUpperCase().includes(state.filter.toUpperCase()))).map((cita, i) => {
                                            let item = cita[0]
                                            // console.log(item);
                                            return (
                                                <div className='bv-card mt-4 '>
                                                    <div className='d-sm-flex m-3'>
                                                        <div className='card-notification flex-center-j-left m-2'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='p-2'>
                                                                <div className='bold f-14'>
                                                                    Dr {item.specialist.firstName} {item.specialist.lastName}
                                                                </div>
                                                                <div className='f-12'>
                                                                    Psicólogo
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col'>

                                                        </div>
                                                        <div className=''>
                                                            <div className='bv-green-card p-2 px-3 bold'>
                                                                Completada
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex mx-3'>
                                                        <div className='col'></div>
                                                        <div><IoIosArrowForward size={18} className='cursor-pointer' onClick={() => {
                                                            setState({ ...state, show_editar_cita: true, cita_editing: item })
                                                        }}></IoIosArrowForward></div>
                                                    </div>
                                                    <div className='d-flex my-3 mx-2 mx-sm-4 bg-gray--txt-black py-2 px-3 bdr-5 f-sm-14'>
                                                        <div className='flex-center'>
                                                            {/* <IoMdCalendar size={18} color={'#000000'}></IoMdCalendar> {weekday[new Date(item.dateOfEvent).getDay()]} {new Date(item.dateOfEvent).getDate()} de {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()} | {new Date(item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes()}-{new Date(item.dateOfEvent).getHours() + 1}:{new Date(item.dateOfEvent).getMinutes()} */}
                                                            <IoMdCalendar size={18} color={'#000000'}></IoMdCalendar> {new Date(item.dateOfEvent).getDate()} de {months[new Date(item.dateOfEvent).getMonth()]} {new Date(item.dateOfEvent).getFullYear()} | {new Date(item.dateOfEvent).getHours()}:{new Date(item.dateOfEvent).getMinutes().toString().length==2?new Date(item.dateOfEvent).getMinutes():new Date(item.dateOfEvent).getMinutes()+"0"}-{new Date(item.dateOfEvent).getHours() + 1}:{new Date(item.dateOfEvent).getMinutes().toString().length==2?new Date(item.dateOfEvent).getMinutes():new Date(item.dateOfEvent).getMinutes()+"0"}
                                                        </div>
                                                        <div className='col'>

                                                        </div>
                                                        <div>
                                                            Sesión: {item.numberOfSession}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </Renderif>

                                </div>
                            </div>
                        </Renderif>

                        <Renderif isTrue={state.show_editar_cita === true}>
                            {/* {console.log(state.cita_editing)}
                            {state.cita_editing.specialist.firstName} */}
                            <div className='col-sm-8 col-12'>
                                <div className='d-flex'>
                                    <div className='h3 cursor-pointer' onClick={() => {
                                        setState({ ...state, show_editar_cita: false })
                                    }}>
                                        <IoIosArrowBack size={24} ></IoIosArrowBack> Datos de la cita
                                    </div>
                                    <Renderif isTrue={new Date(state.cita_editing?.dateOfEvent) < new Date()}>
                                        <div className='bv-green-card p-2 px-3 bold ms-3'>
                                            Completada
                                        </div>
                                    </Renderif>
                                </div>
                                <div className='bv-card mt-4 p-4'>

                                    <div className='separator-h-bottom pb-3'>
                                        <div className='card-notification flex-center-j-left'>
                                            <div className=''>
                                                <div className='avatar-profile'></div>
                                            </div>
                                            <div className='p-2'>
                                                <div className='bold f-14'>
                                                    Dr {state.cita_editing?.specialist?.firstName} {state.cita_editing?.specialist?.lastName}
                                                </div>
                                                <div className='f-12'>
                                                    Psicólogo
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='d-flex separator-h-bottom py-4'>
                                        <div className='flex-center me-3'>
                                            <IoMdCalendar size={24} color={gray40}></IoMdCalendar>
                                        </div>
                                        <div>
                                            <div className='mb-2'>
                                                {weekday[new Date(state.cita_editing?.dateOfEvent).getDay()]} {new Date(state.cita_editing?.dateOfEvent).getDate()} de {months[new Date(state.cita_editing?.dateOfEvent).getMonth()]} {new Date(state.cita_editing?.dateOfEvent).getFullYear()} | {new Date(state.cita_editing?.dateOfEvent).getHours()}:{new Date(state.cita_editing?.dateOfEvent).getMinutes()}-{new Date(state.cita_editing?.dateOfEvent).getHours() + 1}:{new Date(state.cita_editing?.dateOfEvent).getMinutes()}
                                            </div>
                                            <Renderif isTrue={new Date(state.cita_editing?.dateOfEvent) > new Date()}>
                                                {console.log(state.cita_editing?.dateOfEvent)}
                                                <div className='d-flex mb-'>
                                                    <div className='pe-2 flex-center'>
                                                        <div className={`bv-cta-curve bv-cta--option-black bv-icon bv-icon--mid txt-white`} onClick={() => {
                                                            // setState({ ...state, show_question_edit_cita: true })
                                                        }}>
                                                            Editar cita
                                                        </div>
                                                    </div>
                                                    <div className='pe-2 flex-center'>
                                                        <div className={`bv-cta-curve bv-cta--option-red bv-icon bv-icon--mid txt-white`} onClick={() => {
                                                            setState({ ...state, on_cancel: true })
                                                        }}>
                                                            Cancelar
                                                        </div>
                                                    </div>
                                                </div>
                                            </Renderif>

                                        </div>
                                    </div>

                                    <div className='d-flex separator-h-bottom py-4'>
                                        <div className='flex-center me-3'>
                                            <RiMapPin2Line size={24} color={gray40}></RiMapPin2Line>
                                        </div>
                                        <div className='cursor-pointer flex-center text-blue' onClick={() => {
                                            window.open(state.cita_editing?.sessionUrl, '_blank')
                                        }}>
                                            Videollamada <IoOpenOutline size={22}></IoOpenOutline>
                                        </div>
                                    </div>

                                    <div className='d-flex pt-4'>
                                        <div className='flex-center me-3'>
                                            <MdOutlineMessage size={24} color={gray40}></MdOutlineMessage>
                                        </div>
                                        <div>
                                            Comentarios adicionales
                                        </div>
                                    </div>
                                </div>

                                <Renderif isTrue={new Date(state.cita_editing?.dateOfEvent) < new Date()}>
                                    <div className='bv-card my-4 p-4 bold'>
                                        <div>
                                            Seguimiento
                                        </div>
                                        <div className='d-flex mb-2 mt-3 f-sm-14'>
                                            <div className={`bv-transparent-card p-2 px-3 cursor-pointer  ${state.following === 'Acuerdos' ? 'bv-tab--active-blue' : ''}`} onClick={() => {
                                                setState({ ...state, following: 'Acuerdos' })
                                            }}>
                                                Acuerdos
                                            </div>
                                            <div className={`bv-transparent-card p-2 px-3 cursor-pointer  ${state.following === 'Tips' ? 'bv-tab--active-blue' : ''}`} onClick={() => {
                                                setState({ ...state, following: 'Tips' })
                                            }}>
                                                Tips
                                            </div>
                                            <div className={`bv-transparent-card p-2 px-3 cursor-pointer  ${state.following === 'Documentos' ? 'bv-tab--active-blue' : ''}`} onClick={() => {
                                                setState({ ...state, following: 'Documentos' })
                                            }}>
                                                Documentos
                                            </div>
                                            <div className={`bv-transparent-card p-2 px-3 cursor-pointer  ${state.following === 'Comentarios' ? 'bv-tab--active-blue' : ''}`} onClick={() => {
                                                setState({ ...state, following: 'Comentarios' })
                                            }}>
                                                Comentarios
                                            </div>
                                        </div>
                                        <div>
                                            <Renderif isTrue={state.following === 'Acuerdos'}>
                                                {
                                                    state.cita_editing?.agreements?.map((item, i) => {
                                                        return (
                                                            <div key={i} className={`p-2 d-flex  ${i % 2 === 0 ? 'bg-white' : ''}`}>
                                                                <CheckBox text={item?.agreementTitle} id={item?.id} checked={item?.isDone} />
                                                                <div className='col'></div>
                                                                {/* <div className='bv-pill bv-pill--primary cursor-pointer'>Subir Archivo</div> */}
                                                            </div>
                                                        )
                                                    })

                                                }
                                            </Renderif>
                                            <Renderif isTrue={state.following === 'Tips'}>
                                                {
                                                    state.cita_editing?.tips?.map((item, i) => {
                                                        return (
                                                            <div className='w-25-50-100 d-inline-block pe-2' key={i}>
                                                                <TipCard tip={item} tag="¡Nuevo!" i={i} key={i} isAdmin={false}></TipCard>
                                                            </div>
                                                        )
                                                    })

                                                }
                                            </Renderif>
                                            <Renderif isTrue={state.following === 'Documentos'}>
                                                {
                                                    state.cita_editing?.documents?.map((item, i) => {
                                                        return (
                                                            <div className='w-25-50-100 d-inline-block pe-2' key={i}>
                                                                <TipCard tip={item} tag="¡Nuevo!" i={i} key={i} isAdmin={false}></TipCard>
                                                            </div>
                                                        )
                                                    })

                                                }
                                            </Renderif>

                                            <Renderif isTrue={state.following === 'Comentarios'}>
                                                {
                                                    <div>
                                                        {state.cita_editing?.generalInformation}
                                                    </div>

                                                }
                                            </Renderif>
                                        </div>
                                    </div>
                                </Renderif>
                            </div>

                        </Renderif>

                        <div className='col-sm-2'>

                        </div>

                    </div>



                </div>
            </div>
        </>
    )
}

const CitaDetail = ({ ...props }) => {
    const [state, setState] = useState({
        tab: 0
    })
    const tips = props.cita.tips;
    console.log(tips);
    const arr = [1, 1, 1, 1, 1, 1, 1]
    const tip = {
        image: ''
    }
    return (
        <div className='d-grid'>
            <div className='d-flex p-1'>
                <div className='col'></div>
                <div className='py-2 d-flex'>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 0 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 0 }) }}>
                        Acuerdos
                        <span className='text-blue f-14 bold ms-2'>{props.cita.agreements.length}</span>
                    </div>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 1 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 1 }) }}>
                        <div className='bv-icon me-1'><MdTipsAndUpdates></MdTipsAndUpdates></div>
                        <div>Tips </div>
                        <span className='text-blue f-14 bold ms-2'>{props.cita.tips.length}</span>
                    </div>

                    <div className={`bv-tab bv-tab--primary ${state.tab === 2 ? 'bv-tab--active' : ''}`} onClick={() => { setState({ ...state, tab: 2 }) }}>
                        <div className='bv-icon me-1'><AiFillFolder></AiFillFolder></div>
                        <div>Documentos</div>
                        <span className='text-blue f-14 bold ms-2'>{props.cita.documents.length}</span>
                    </div>
                </div>
            </div>


            <Renderif isTrue={state.tab === 0}>
                <div className=' d-flex '>
                    <div className='col'>



                        {
                            props.cita.agreements.map((item, i) => {
                                return (
                                    <div key={i} className={`p-2 d-flex  ${i % 2 === 0 ? 'bg-white' : ''}`}>
                                        <CheckBox text={item?.agreementTitle} id={item?.id} checked={item?.isDone} />
                                        <div className='col'></div>
                                        {/* <div className='bv-pill bv-pill--primary cursor-pointer'>Subir Archivo</div> */}
                                    </div>
                                )
                            })

                        }

                    </div>

                </div>
            </Renderif>

            <Renderif isTrue={state.tab === 1}>
                <div className='overflow-auto no-wrap px-2 pb-4 pt-1 w-100 hide-scroll'>

                    {tips.map((item, i) => {
                        console.log(item)
                        return (
                            <div className='w-25-50-100 d-inline-block pe-2' key={i}>
                                <TipCard tip={item} tag="¡Nuevo!" i={i} key={i} isAdmin={false}></TipCard>
                            </div>
                        )
                    })}
                </div>
            </Renderif>

            <Renderif isTrue={state.tab === 2}>
                <div className=' d-flex '>
                    <div className='col'>

                        {
                            props.cita.documents.map((item, i) => {
                                return (

                                    <div className='p-2 d-flex align-items-center bg-white'>
                                        <div className='bv-icon'><AiFillFile color='#CCC'></AiFillFile></div>
                                        <div className='f-12 text-gray ps-2'>{item?.title}</div>
                                        <div className='col'></div>
                                        <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                            window.open(item.documentUrl, '_blank')
                                        }}>Ver Archivo</div>
                                    </div>
                                )
                            })

                        }









                    </div>

                </div>
            </Renderif>

        </div>
    )
}

const CitaItem = ({ ...props }) => {
    // console.log(props.cita)
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    var months = new Array(7);
    months[0] = "January";
    months[1] = "Febrary";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "July";
    months[7] = "August";
    months[8] = "September";
    months[9] = "Octuber";
    months[10] = "November";
    months[11] = "December";
    return (
        <div className='b-bottom align-items-start p-1 highlight-hover--light px-3'>

            <div className='d-flex'>
                <div>
                    <div className='text-gray f-14 bold'>{props.cita[0].specialist?.firstName} {props.cita[0].specialist?.lastName}</div>
                    <div className='text-gray f-10'>{props.cita[0].specialist?.email}</div>
                </div>
                <div className='col'></div>
                <div className='f-12 bold text-gray'>
                    #{props.cita[0].specialist?.proceedings}
                </div>
            </div>
            <div className='d-flex mt-2'>
                <div className='d-flex justify-content-start'>
                    <div className='text-gray f-12'>{weekday[new Date(props.cita[0].ddateOfEventate).getDay()]} {new Date(props.cita[0].dateOfEvent).getDate()} {months[new Date(props.cita[0].dateOfEvent).getMonth()]} {new Date(props.cita[0].dateOfEvent).getFullYear()}</div>
                </div>
                <div className='d-flex justify-content-center ps-1'>
                    <div className='text-gray f-12'>{new Date(props.cita[0].dateOfEvent).getHours()}:00</div>
                </div>



                <div className='d-flex justify-content-end ps-2'>
                    <div className='text-gray f-12'>Sesión: <span className='bold text-black'>{props.cita[0].numberOfSession}</span></div>
                </div>
            </div>



        </div>
    )
}